var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "accordion-element" },
    [
      _c("div", { staticClass: "accordion-trigger", attrs: { role: "tab" } }, [
        _c(
          "a",
          {
            directives: [
              {
                name: "b-toggle",
                rawName: "v-b-toggle",
                value: _vm.id,
                expression: "id"
              }
            ],
            staticClass:
              "sw--font-size-22 sw-dms__link--inherit-color sw--padding-vert-4 sw-grid-flex sw-grid-flex--align-center",
            attrs: { href: "#", tabindex: "0", role: "button" },
            on: {
              click: function($event) {
                $event.preventDefault()
              }
            }
          },
          [
            _vm._t("trigger"),
            _vm._v(" "),
            _c("span", {
              staticClass: "icon-chevron-down sw--margin-left-auto"
            }),
            _vm._v(" "),
            _c("span", { staticClass: "icon-chevron-up sw--margin-left-auto" })
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "b-collapse",
        {
          attrs: {
            id: _vm.id,
            accordion: _vm.group,
            role: "tabpanel",
            visible: _vm.expanded
          }
        },
        [_vm._t("target")],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }